import React, { Component } from "react";
import * as s from "./DocumentDropdown.module.scss";
import { Icons } from "src/libs/assets";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children?: any;
  title: string;
  alwaysOpen?: boolean;
  hideTopBorder?: boolean;
  openByDefault?: boolean;
}

interface State {
  open: boolean;
}

export class DocumentDropdown extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      open: props.alwaysOpen || props.openByDefault
    };
  }

  toggleDropdown = () => {
    if (this.props?.alwaysOpen) return;

    this.setState({
      open: !this.state.open
    });
  };

  render() {
    const { children, className, title, alwaysOpen, hideTopBorder } = this.props;
    const { open } = this.state;

    const dropdownClasses = [s.documentDropdown];
    const dropdownContentClasses = [s.dropdownContent];
    const dropdownIconClasses = [s.dropdownChevronIcon];
    const dropdownHeaderClasses = [s.documentDropdownHeader];
    let icon = Icons.chevronDown_large;

    if (open || alwaysOpen) {
      dropdownContentClasses.push(s.open);
      icon = Icons.chevronUp_large;
    }

    if (className) {
      dropdownClasses.push(className);
    }

    if (hideTopBorder) {
      dropdownHeaderClasses.push(s.hideTopBorder);
    }

    if (alwaysOpen) {
      dropdownIconClasses.push(s.hiddenIcon);
    }

    return (
      <div className={dropdownClasses.join(" ")}>
        <div className={dropdownHeaderClasses.join(" ")} onClick={this.toggleDropdown}>
          <h6 className={s.dropdownTitle}>{title}</h6>
          <img
            src={icon}
            alt="dropdown-chevron"
            className={dropdownIconClasses.join(" ")}
          />
        </div>
        <div className={dropdownContentClasses.join(" ")}>{children}</div>
      </div>
    );
  }
}
